import { create } from "zustand";

export interface Session {
  handle: number;
  vaultId: string;
  displayName: string;
  unlockedAt: number;
}

interface SessionState {
  session: Session | null;
  setSession: (s: Session) => void;
  clear: () => void;
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
  clear: () => set({ session: null }),
}));
